import axios from "axios";

export const getCountDisuabiguationJimpi = async (): Promise<number> => {
    const response = await axios.get('booking/import/countDisambiguation');
    return response.data;
};
